import { render, staticRenderFns } from "./wxjq.vue?vue&type=template&id=33d4f9d0&scoped=true"
import script from "./wxjq.vue?vue&type=script&lang=js"
export * from "./wxjq.vue?vue&type=script&lang=js"
import style0 from "./wxjq.vue?vue&type=style&index=0&id=33d4f9d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d4f9d0",
  null
  
)

export default component.exports